module.exports = __webpack_public_path__ + "img/yixiangsui.c8bbcf4f.png";